import { atom } from 'recoil';

export interface ErrorPageContent {
  backgroundImage: string;
  mobileBackgroundImage: string;
  bodyContent: string;
  contentFontColor: string;
  legalDisclaimer: string;
  legalDisclaimerFontColor: string;
  title: string;
  titleDisclaimer: string;
}

export const ErrorPageContentState = atom<ErrorPageContent>({
  key: 'ErrorPageContentSate',
  default: {
    backgroundImage: '',
    mobileBackgroundImage: '',
    bodyContent: '',
    contentFontColor: '',
    legalDisclaimer: '',
    legalDisclaimerFontColor: '',
    title: '',
    titleDisclaimer: '',
  },
});
